<template>
    <div>
        <Transition
            name="fade"
            mode="out-in"
        >
            <div
                v-show="hasCoupons"
                class="Coupons"
            >
                <div>
                    <PageTitle class="Coupons-title">
                        {{ $t('personal-account.coupons.title') }}
                    </PageTitle>
                    <div class="Coupons-actionContainer">
                        <RoundedButton
                            :label="$t('personal-account.coupons.actions.add-coupon')"
                            type="white"
                            data-cy="button.add-coupon"
                            @buttonClicked="$router.push({name: 'personalAccountAddCoupon'})"
                        />
                    </div>
                </div>

                <div class="Coupons-globalContainer">
                    <div class="Coupons-container">
                        <div
                            v-for="(couponsByService, service) in arrayCouponsByService"
                            :key="service"
                            class="Coupons-block"
                        >
                            <div class="Coupons-blockHeader">
                                <div class="Coupons-service">
                                    {{ $t('personal-account.coupons.service.'+couponsByService.service) }}
                                </div>
                            </div>
                            <Block
                                :withoutPadding="true"
                            >
                                <List :items="couponsByService.coupons">
                                    <template #listItem="{item}">
                                        <CouponItem
                                            :coupon="item"
                                        />
                                    </template>
                                </List>
                            </Block>
                        </div>
                    </div>
                    <div class="Coupons-filter">
                        <CircleIconButton
                            class="Coupons-filterButton"
                            icon="f2m-filter"
                            data-cy="button.filter"
                            @buttonClicked="toggleFiltersModal"
                        />
                    </div>
                </div>
            </div>
        </Transition>
        <Transition
            name="fade"
            mode="out-in"
        >
            <div
                v-show="hasCoupons===false"
                class="Coupons"
            >
                <div class="Coupons-empty">
                    <span class="f2m-promocodes Coupons-emptyIcon" />
                    <div class="Coupons-emptyTitle">
                        {{ $t('personal-account.coupons.empty.title') }}
                    </div>
                    <div class="Coupons-emptyDescription">
                        {{ $t('personal-account.coupons.empty.description') }}
                    </div>
                    <Block class="Coupons-emptyActions">
                        <RoundedButton
                            :label="$t('personal-account.coupons.empty.add-coupon')"
                            type="reversed"
                            class="Coupons-emptyAddButton"
                            data-cy="button.add-coupon-empty"
                            @buttonClicked="$router.push({name: 'personalAccountAddCoupon'})"
                        />
                    </Block>
                </div>
            </div>
        </Transition>
        <FullScreenModal
            :showModal="showFiltersModal"
            type="custom"
            class="Coupons-filterModal"
        >
            <div class="col col-sm-12 col-md-6 offset-md-3">
                <div class="Coupons-filterModalHeader">
                    <div class="Coupons-filterModalHeaderTitle">
                        {{ $t('personal-account.coupons.filter.title') }}
                    </div>
                    <RoundedButton
                        type="white"
                        :label="$t('personal-account.coupons.filter.reset')"
                        data-cy="button.reset-filter"
                        @buttonClicked="resetFilters"
                    />
                </div>
                <div class="Coupons-filterModalSubTitle">
                    {{ $t('personal-account.coupons.filter.byServices') }}
                </div>
                <div class="Coupons-filterModalServiceContainer">
                    <div class="row">
                        <div class="col col-6">
                            <RoundedButton
                                type="white"
                                :label="$t('personal-account.coupons.filter.all')"
                                class="Coupons-filterModalServiceButton"
                                :active="selectedService === 'all'"
                                data-cy="button.filter-all"
                                @buttonClicked="selectedService = 'all'"
                            />
                        </div>
                        <div class="col col-6">
                            <RoundedButton
                                type="white"
                                :label="$t('personal-account.coupons.filter.carsharing')"
                                class="Coupons-filterModalServiceButton"
                                :active="selectedService === 'carsharing'"
                                data-cy="button.filter-carsharing"
                                @buttonClicked="selectedService = 'carsharing'"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col col-6">
                            <RoundedButton
                                type="white"
                                :label="$t('personal-account.coupons.filter.rent')"
                                class="Coupons-filterModalServiceButton"
                                :active="selectedService === 'rent'"
                                data-cy="button.filter-rent"
                                @buttonClicked="selectedService = 'rent'"
                            />
                        </div>
                        <div class="col col-6">
                            <RoundedButton
                                type="white"
                                :label="$t('personal-account.coupons.filter.park')"
                                class="Coupons-filterModalServiceButton"
                                :active="selectedService === 'park'"
                                data-cy="button.filter-park"
                                @buttonClicked="selectedService = 'park'"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col col-6">
                            <RoundedButton
                                type="white"
                                :label="$t('personal-account.coupons.filter.refill')"
                                class="Coupons-filterModalServiceButton"
                                :active="selectedService === 'refill'"
                                data-cy="button.filter-refill"
                                @buttonClicked="selectedService = 'refill'"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="Coupons-filterModalFooter row">
                    <div class="col col-sm-12 col-md-6 offset-md-3 ">
                        <div class="row">
                            <div class="col col-4 col-md-3 offset-md-1">
                                <RoundedButton
                                    :label="$t('personal-account.coupons.filter.cancel')"
                                    class="Coupons-filterModalFooterButton"
                                    data-cy="button.cancel-filter"
                                    @buttonClicked="toggleFiltersModal"
                                />
                            </div>
                            <div class="col col-8 col-md-7">
                                <RoundedButton
                                    :label="$t('personal-account.coupons.filter.submit', {count})"
                                    type="reversed"
                                    class="Coupons-filterModalSubmitButton Coupons-filterModalFooterButton"
                                    :loading="filterLoading"
                                    :inactive="count === 0"
                                    data-cy="button.submit-filter"
                                    @buttonClicked="submitFilters"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </FullScreenModal>
    </div>
</template>

<script>
import PageTitle from '@/components/PageTitle.vue';
import * as mutationTypes from "@/store/mutation-types";
import {GET_COUPONS} from "@/store/action-types";
import CouponItem from "@/components/CouponItem.vue";
import Transition from "@/components/Transition.vue";
import dayjs from "dayjs";

import RoundedButton from "@/components/common/RoundedButton.vue";
import FullScreenModal from "@/components/FullScreenModal.vue";
import CircleIconButton from "@/components/CircleIconButton.vue";
import List from "@/components/List.vue";
import Vue from "vue";
import Component from "vue-class-component";

import {Block} from '@free2move/vuejs-components'

import _ from "lodash";

@Component({
    components: {
        List,
        FullScreenModal,
        CouponItem,
        PageTitle,
        Transition,
        RoundedButton,
        CircleIconButton,
        Block
    },
    watch:{
        selectedService() {
            this.countResults();
        },
    }
})
export default class Coupons extends Vue {
    data() {
        return {
            coupons: [],
            hasCoupons: null,
            totalAmount: 0,
            showFiltersModal: false,
            count: 0,
            filterLoading: false,
            selectedService: 'all',
            initialValues: {
                selectedYear: '0',
                selectedMonth: '0',
                selectedService: 'all'
            },
        }
    }

    mounted() {
        this.getCoupons();
        this.countResults();
    }

    get arrayCouponsByService() {
        return this.coupons.reduce((acc, coupon) => {
            const service = coupon.modelId.split('+')[0];
            const keyService = _.findIndex(acc, (item) => item.service === service);
            if (keyService === -1) {
                acc.push({
                    service,
                    coupons: [coupon]
                });
            } else {
                acc[keyService].coupons.push(coupon);
            }
            return acc;
        }, []);
    }

    get conditions() {
        return {
            to: {$gte: dayjs().format('YYYY-MM-DD')},
        }
    }

    getCoupons() {
        this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, true);
        this.$store.dispatch(GET_COUPONS, {
            callback: function (data) {
                this.coupons = data.coupons;
                this.totalAmount = data.totalAmount;
                this.hasCoupons = this.coupons.length > 0;
                this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, false);
            }.bind(this),
            data: {
                conditions: this.conditions,
                ...(this.selectedService !== 'all' && {service: this.selectedService})
            }
        });
    }

    toggleFiltersModal() {
        this.showFiltersModal = !this.showFiltersModal;
    }

    submitFilters() {
        this.toggleFiltersModal();
        this.getCoupons();
    }

    resetFilters() {
        this.selectedService = this.initialValues.selectedService;
    }

    countResults() {
        this.loading = true;
        this.$store.dispatch(GET_COUPONS, {
            callback: function (data) {
                this.count = data.count;
                this.loading = false;
            }.bind(this),
            data: {
                count: true,
                conditions: this.conditions,
                ...(this.selectedService !== 'all' && {service: this.selectedService})
            }
        });
    }
}
</script>

<style lang="scss" scoped>
.Coupons {
    width: 100%;

    @media (max-width: $f2m-desktop-breakpoint) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: calc(100vh - 150px);
        position: relative;
    }


    &-container {
        flex-grow:1;
        margin-bottom: 28px;

        @media (max-width: $f2m-desktop-breakpoint) {
            max-width: 100%;
        }

    }

    &-globalContainer {
        display: flex;
        gap: 38px;

        @media (max-width: $f2m-desktop-breakpoint) {
            gap: 0;
        }
    }

    &-service {
        font-size: 18px;
        line-height: 22px;
        color: white;
        font-weight: bold;
        margin-left: 12px;
    }

    &-blockHeader {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 14px;
    }

    &-block {
        margin-bottom: 28px;
    }
    &-filter {
        margin: 38px 0 0 0;

        @media (max-width: $f2m-desktop-breakpoint) {
            margin: 0;
        }
    }

    &-filterButton {
        @media (max-width: $f2m-desktop-breakpoint) {
            position: fixed;
            right: 20px;
            bottom: 40px;
            z-index: 1;
        }
    }

    &-title {
        margin-bottom: 8px;
    }

    &-actionContainer{
        margin-bottom: 40px;
    }

    &-filterModalHeader{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 185px;
        margin-bottom: 48px;

        @media (max-width: $f2m-desktop-breakpoint) {
            margin-top: 60px;
        }
    }

    &-filterModalHeaderTitle{
        font-size: 30px;
        line-height: 36px;
        font-weight: bold;
        letter-spacing: 0.818182px;
        color: $color-white;
    }

    &-filterModalFooter {
        background-color: $color-white;
        padding: 15px;
    }

    &-filterModalSubTitle{
        font-size: 22px;
        line-height: 26px;
        color: $color-white;
        margin-bottom: 15px;
    }

    &-filterModalServiceContainer{
        .row{
            margin-bottom: 20px;
            &:last-child{
                margin-bottom: 40px;
            }
        }
    }

    &-filterModalServiceButton {
        width: 100%;
    }

    &-filterModalDateContainer {
        .col {
            margin-bottom: 20px;
            &:last-child {
                margin-bottom: 0;
            }
        }
    }
    &-filterModalFooterButton {
        width: 100%;
    }

    &-empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        height: 100%;
        color: #fff;
        max-width: 495px;

        @media (max-width: $f2m-desktop-breakpoint) {
            max-width: 100%;
        }

        &Actions{
            padding: 28px;
            max-width: 495px;
        }

        &AddButton{
            width: 100%;
        }

        &Icon {
            font-size: 200px;
            display: block;
            margin-bottom: 42px;
        }

        &Title {
            font-size: 30px;
            line-height: 36px;
            margin-bottom: 24px;
        }

        &Description {
            font-weight: 400;
            font-size: 18px;
            line-height: 22px;
            letter-spacing: 0.3px;
            max-width: 320px;
            margin-bottom: 75px;
        }
    }
}
</style>
